import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { message } from 'antd';

export const baseURI = '/estructura-organizacional/honorarios-asimilados';
export const baseURI2 = '/estructura-organizacional/honorarios-asimilados-vista-optimized/';
export const baseURI3 = '/estructura-organizacional/honorarios-asimilados-without-filtered/';

const getValuesAndConfig = (values) => {
  const files = ['foto', 'firma_electronica'];
  const config = hasFiles(values, files) ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  const formattedValues = getFormattedValues(values, {
    files,
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};
/**
 * GET Honorarios Asimilados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHonorariosAsimilados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Honorario Asimilado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHonorarioAsimilado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHonorarioAsimilado = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    // onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHonorarioAsimilado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    // onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

// /**
//  * POST Honorario Asimilado
//  * @param {object} values
//  * @returns {Promise<object|boolean>}
//  */
// export const postHonorarioAsimilado = async (values) => {
//   try {
//     // Usar spread operator (...) para pasar data y config
//     const response = await API.post(baseURI, ...getValuesAndConfig(values));
//     onSuccess(response, 'Agregado correctamente');
//     return response.data;
//   } catch (err) {
//     onError(err);
//     return false;
//   }
// };

// /**
//  * PATCH Honorario Asimilado
//  * @param {number} id
//  * @param {object} values
//  * @returns {Promise<object|boolean>}
//  */
// export const patchHonorarioAsimilado = async (id, values) => {
//   try {
//     const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
//     onSuccess(response, 'Editado correctamente');
//     return response.data;
//   } catch (err) {
//     onError(err);
//     return false;
//   }
// };

/**
 * DELETE Honorario Asimilado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHonorarioAsimilado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Nivel de Estudio
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarHonorarioAsimilado = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getHonorarioAsimiladoVistaoptimizado = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Honorarios Asimilados sin filtrado {raw query}
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHonorariosAsimiladosWithoutFilter = async (params) => {
  try {
    const response = await API.get(baseURI3, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * AUTORIZAR honorario asimilado
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const putAutorizarContratacionHonorarioAsimilado = async (payload) => {
  try {
    const response = await API.put(
      '/estructura-organizacional/autorizar-contratacion-honorario-asimilado/',
      payload,
    );

    onSuccess(response, 'Contratación directa realizada correctamente');
    return response.data;
  } catch (err) {
    // Detecta correctamente si es lista o string
    const data = err?.response?.data;

    const backendMessage = Array.isArray(data?.estados_globales)
      ? data.estados_globales[0]
      : data?.estados_globales
          || data?.message
          || data
          || 'Ocurrió un error';

    message.error(backendMessage);
    throw err;
  }
};
